// extracted by mini-css-extract-plugin
module.exports = {"questionMark":"_2TNIf","tooltip":"_3qDPt","title":"_3X6ke","content":"_2HXPJ"};